import { Component, Inject, OnInit } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import {
  MatDialog,
  MatDialogRef,
  MAT_DIALOG_DATA,
} from '@angular/material/dialog';
import { Speciality } from 'src/app/models/speciality.model';
import { SnackbarService } from 'src/app/services/snackbar.service';
import { SpecialityService } from 'src/app/services/speciality.service';
import { ConfirmationDialogComponent } from '../../shared/index';

@Component({
  selector: 'my-rep-speciality-form',
  templateUrl: './speciality-form.component.html',
  styleUrls: ['./speciality-form.component.scss'],
})
export class SpecialityFormComponent implements OnInit {
  public specialityFormGroup: FormGroup;
  public isLoading: boolean = false;
  public isEditMode: boolean = false;

  constructor(
    private dialogRef: MatDialogRef<SpecialityFormComponent>,
    @Inject(MAT_DIALOG_DATA) public data: Speciality,
    private snackbarService: SnackbarService,
    private specialityService: SpecialityService,
    private dialog: MatDialog
  ) {}

  public ngOnInit(): void {
    this.isEditMode = !!this.data?._id;
    this.specialityFormGroup = new FormGroup({
      _id: new FormControl(this.data?._id || ''),
      name: new FormControl(this.data?.name || '', [Validators.required]),
    });
  }

  public submit() {
    if (this.specialityFormGroup.invalid) {
      this.specialityFormGroup.markAllAsTouched();
      return;
    }
    this.isLoading = true;
    const name = this.specialityFormGroup.get('name').value.trim();
    const request = this.isEditMode
      ? this.specialityService.updateSpeciality(this.data._id, { name })
      : this.specialityService.createSpeciality({ name });

    request.subscribe(
      () => {
        this.isLoading = false;
        this.dialogRef.close(true);
        this.dialog.open(ConfirmationDialogComponent, {
          width: '40rem',
          autoFocus: false,
          data: {
            icon: 'tick',
            title: this.isEditMode ? 'Speciality Updated' : 'Speciality Added',
            message: this.isEditMode
              ? 'The speciality has been updated successfully!'
              : 'New speciality has been added successfully!',
          },
        });
      },
      (err) => {
        this.snackbarService.openSnackBar(err.error.message, 'Close');
        this.isLoading = false;
      }
    );
  }

  public cancelForm() {
    this.dialogRef.close();
  }
}
